import mainApiClient from "../../helpers/services/main-api-client";
import {
  CreateDemoRequestBody,
  DemoRequest,
  DemoStatus,
} from "../interfaces/DemoRequest";

export const demoApiService = {
  createDemoRequest(body: CreateDemoRequestBody) {
    return mainApiClient()
      .post(`demo-request`, body)
      .then(({ data }) => data.payload.demoRequest as DemoRequest);
  },
  getDemoRequests(status?: DemoStatus) {
    return mainApiClient()
      .get(`demo-request`, { params: status ? { status } : {} })
      .then(({ data }) => data.payload.demoRequests as DemoRequest[]);
  },
  updateDemoRequestStatus(id: number, status: DemoStatus) {
    return mainApiClient()
      .patch(`demo-request/${id}`, { status })
      .then(({ data }) => data.payload.demoRequest as DemoRequest);
  },
};
